import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BatteryContainer3D } from './BatteryContainer3D';
import { BatteryStatusSummary } from './BatteryStatusSummary';
import { ContainerScrollBar } from './ContainerScrollBar';
import { Truck, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Container, Battery } from '@/hooks/useBatteryContainers';

interface InTransitSectionProps {
  containers: Container[];
  batteries: Battery[];
  allocations?: Map<string, string>;
  onAddContainer?: () => void;
  onAddBatteries?: (container: Container) => void;
  onEditContainer?: (container: Container) => void;
  onDeleteContainer?: (container: Container) => void;
  onEditBattery?: (battery: Battery) => void;
  onDeleteBattery?: (battery: Battery) => void;
  onAllocateBattery?: (battery: Battery) => void;
  onBatteryDrop?: (batteryId: string, leadId: string) => void;
  onBookToStock?: (container: Container) => void;
}

export const InTransitSection: FC<InTransitSectionProps> = ({
  containers,
  batteries,
  allocations,
  onAddContainer,
  onAddBatteries,
  onEditContainer,
  onDeleteContainer,
  onEditBattery,
  onDeleteBattery,
  onAllocateBattery,
  onBatteryDrop,
  onBookToStock
}) => {
  const inTransitBatteries = batteries.filter(b => b.container_id);

  return (
    <Card className="h-full flex flex-col border-l-4 border-l-blue-500">
      <CardHeader className="pb-3 flex-row items-center justify-between space-y-0">
        <CardTitle className="flex items-center gap-2 text-blue-700 dark:text-blue-400">
          <Truck className="h-5 w-5" />
          Onderweg
        </CardTitle>
        <Button size="sm" variant="outline" onClick={onAddContainer}>
          <Plus className="h-4 w-4 mr-1" />
          Container
        </Button>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto space-y-6">
        {containers.length > 0 ? (
          <>
            <ContainerScrollBar
              containers={containers}
              batteries={batteries}
              allocations={allocations}
              onBatteryDrop={onBatteryDrop}
              onAddBatteries={onAddBatteries}
              onEditContainer={onEditContainer}
              onDeleteContainer={onDeleteContainer}
              onEditBattery={onEditBattery}
              onDeleteBattery={onDeleteBattery}
              onAllocateBattery={onAllocateBattery}
              onBookToStock={onBookToStock}
            />
            <BatteryStatusSummary batteries={inTransitBatteries} allocations={allocations} />
          </>
        ) : (
          <div className="text-center py-8">
            <p className="text-muted-foreground mb-4">Geen containers onderweg</p>
            <Button variant="outline" onClick={onAddContainer}>
              <Plus className="h-4 w-4 mr-2" />
              Container toevoegen
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
